'use client';

interface CustomerLogoProps {
	className?: string;
}

function CustomerLogo({ className }: CustomerLogoProps) {
	return (
		<div className={className ?? 'text-center'}>
			<img src="/api/public/logo" className="p-24 w-full max-w-[300px]" alt="Customer Logo" />
		</div>
	);
}

CustomerLogo.displayName = 'CustomerLogo';

export { CustomerLogo };
export default CustomerLogo;

